import React from "react";
import { Divider, useTheme } from "@mui/material";
import { RightArea } from "@components/ListItemCardCst/style";
import { CardGenericCstProps } from "./types";
import { CardRow, InfoArea } from "./styles";

// ListCardItemCst ha troppa logica e complessita' per essere comodo da riutilizzare nell'interfaccia.
// Questo componente ha l'obbiettivo di essere numb e avere le informazioni passate dal padre riguardo i contenuti. L'unica cosa gestita qua e' il layout orizzontale delle due sezioni che lo compongono. Se si vuole un layout verticale si puo' creare un componente copia apposito ma con quel tipo di layout
const CardGenericCst: React.FC<CardGenericCstProps> = ({
  left,
  right,
  selected = false,
  onClick,
  showAccent = false,
}) => {
  const theme = useTheme();

  return (
    <CardRow
      selected={selected}
      onClick={onClick}
      sx={{ cursor: onClick ? "pointer" : "default" }}
    >
      {showAccent && (
        <Divider
          orientation="vertical"
          flexItem
          sx={{ borderColor: theme.palette.divider, marginRight: "0.5rem" }}
        />
      )}
      <InfoArea>{left}</InfoArea>
      {right && <RightArea>{right}</RightArea>}
    </CardRow>
  );
};

export default CardGenericCst;
